<template>
    <div>
        <div class="fixed pin z-50 overflow-auto py-8"
             v-on:click.self="$emit('close')"
             style="background-color: rgba(0, 0, 0, 0.1)">
            <div class="ml-4 border-2 border-blue-dark rounded-lg my-32 fixed pin-l pin-t m-auto flex-col flex w-1/5 overflow-x-auto bg-grey-lightest shadow-xl">
                <div class="">
                    <div class="flex justify-between px-4 pt-4 pb-2 border-b bg-white text-black">
                        <slot name="header"></slot>
                        <slot name="save"></slot>
                    </div>
                    <div class="rounded-b-lg p-4">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        name: 'ModalBottom',

        created() {
            document.body.className = "fixed overflow-none";
        },

        destroyed() {
            document.body.className = "";
        }
    }
</script>
